import {
  decodePortalListingLotReference,
  decodeReference,
} from '@realadvisor/listings';

export type SubjectListingRefs = {
  lot_reference?: string | null;
  lot_reference_aliases?: ReadonlyArray<{
    reference_alias_decoded?: number | null;
  }> | null;
};

type ScrapedListingRefs = {
  original_id?: string | null;
  lot_reference?: string | null;
  agency_reference?: string | null;
};

export const getSubjectReferenceIds = (
  subject: SubjectListingRefs | null | undefined,
): Set<number> => {
  const ids = new Set<number>();
  for (const alias of subject?.lot_reference_aliases ?? []) {
    if (alias.reference_alias_decoded != null) {
      ids.add(alias.reference_alias_decoded);
    }
  }
  const ownReference =
    subject?.lot_reference != null
      ? decodeReference(subject.lot_reference.trim())
      : null;
  if (ownReference != null) {
    ids.add(ownReference);
  }
  return ids;
};

const scrapedListingReferenceIds = (
  listing: ScrapedListingRefs,
): Array<number | null> => [
  listing.original_id != null
    ? decodePortalListingLotReference(listing.original_id.trim())
    : null,
  listing.lot_reference != null
    ? decodePortalListingLotReference(listing.lot_reference.trim())
    : null,
  listing.agency_reference != null
    ? decodePortalListingLotReference(listing.agency_reference.trim())
    : null,
];

export const excludeSubjectListing = <
  Row extends { listing?: ScrapedListingRefs | null },
>(
  rows: Row[],
  subjectReferenceIds: ReadonlySet<number>,
): Row[] => {
  if (subjectReferenceIds.size === 0) {
    return rows;
  }
  return rows.filter(
    row =>
      row.listing == null ||
      !scrapedListingReferenceIds(row.listing).some(
        id => id != null && subjectReferenceIds.has(id),
      ),
  );
};
